// extracted by mini-css-extract-plugin
export default {"container":"AmountSection_container__IrMn4","label":"AmountSection_label__04hZ5"};